import styled, { css } from 'styled-components/native';
import { RFValue } from 'react-native-responsive-fontsize';
import { Dimensions, Platform } from 'react-native';
import { getBottomSpace } from 'react-native-iphone-screen-helper';
import Feather from 'react-native-vector-icons/Feather';
import LinearGradient from 'react-native-linear-gradient';
import FontAwesome5 from 'react-native-vector-icons/FontAwesome5';

interface Package {
  active: boolean;
}

const { width } = Dimensions.get('window');

export const Container = styled.View`
  flex: 1;
  background-color: ${({ theme }) => theme.colors.background};
`;

export const Content = styled.ScrollView`
  flex: 1;
`;

export const Price = styled.Text`
  color: ${({ theme }) => theme.colors.purple_2_shadow_white};
  font-size: ${RFValue(12)}px;
  font-family: ${({ theme }) => theme.fonts.semibold};
`;

export const Section = styled.View`
  margin-top: ${RFValue(12)}px;
  padding: 0 24px;
  border-top-width: 1px;
  border-top-color: ${({ theme }) => theme.colors.border};

  margin-top: ${RFValue(16)}px;
  padding-top: ${RFValue(16)}px;
`;

export const List = styled.View``;

export const SectionHeader = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-left: 16px;
  padding-right: 24px;
  margin-bottom: ${RFValue(12)}px;
`;

export const SectionTitle = styled.Text`
  color: ${({ theme }) => theme.colors.title};
  font-size: ${RFValue(14)}px;
  font-family: ${({ theme }) => theme.fonts.semibold};
`;

export const SectionTitle2 = styled.Text`
  color: ${({ theme }) => theme.colors.text};
  font-size: ${RFValue(10)}px;
  font-family: ${({ theme }) => theme.fonts.regular};
`;

export const PackageSelect = styled.TouchableOpacity<Package>`
  flex: 1;
  justify-content: center;
  align-items: center;

  border: 2px solid ${({ theme }) => theme.colors.border};
  border-radius: ${RFValue(12)}px;

  ${({ active }) =>
    active &&
    css`
      border: 2px solid ${({ theme }) => theme.colors.blue};
    `}
`;

export const PackageSelectValue = styled.Text`
  color: ${({ theme }) => theme.colors.text_dark};
  font-size: ${RFValue(14)}px;
  text-align: center;

  font-family: ${({ theme }) => theme.fonts.semibold};
`;

export const PackageSelectValueDescription = styled.Text`
  color: ${({ theme }) => theme.colors.text_dark};
  font-size: ${RFValue(10)}px;
  text-align: center;
  line-height: ${RFValue(11)}px;
  padding-top: ${RFValue(2)}px;
  font-family: ${({ theme }) => theme.fonts.regular};
`;

export const QuantityColumn = styled.View`
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(6)}PX;
`;
export const QuantityContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin-top: 1px;
`;
export const QuantityButton = styled.TouchableOpacity`
  width: ${RFValue(25)}px;
  height: ${RFValue(25)}px;
  align-items: center;
  justify-content: center;
  border-radius: ${RFValue(20)}px;
  border: 1px solid ${({ theme }) => theme.colors.border};
`;
export const QuantityIcon = styled(Feather)`
  color: ${({ theme }) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;
`;
export const Quantity = styled.Text`
  padding: 0 ${RFValue(8)}px;
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;
`;

export const Footer = styled.View`
  padding: 0 16px;
  padding-top: ${RFValue(12)}px;
  padding-bottom: ${getBottomSpace() && Platform.OS === 'ios'
    ? 0
    : RFValue(20)}px;
`;

export const FuelList = styled.View`
  flex-direction: row;
  flex-wrap: wrap;
  padding: ${RFValue(10)}px;
  padding-top: 0px;
  margin-bottom: ${RFValue(10)}px;
`;
export const FuelItemContainer = styled.Pressable<{
  active: boolean;
  highlight?: boolean;
}>`
  flex-direction: row;
  width: ${(width - 28) / (width < 320 ? 2 : 3)}px;
  border-width: 2px;
  border-style: solid;
  padding: 4px;

  border-radius: ${RFValue(13)}px;
  opacity: 1;
  border-color: ${({ active, highlight, theme }) =>
    active ? theme.colors.blue : highlight ? '#B8100F' : 'transparent'};
`;

export const FuelItemWrapper = styled.View`
  position: relative;
`;

export const EtanolBalloon = styled.View`
  margin-top: ${RFValue(5)}px;
  margin-right: -${RFValue(12

  )}px; 
  margin-left: -${RFValue(8)}px;
  background-color: #B8100F;
  border-radius: ${RFValue(8)}px;
  padding: ${RFValue(5)}px ${RFValue(6)}px;
  align-self: center;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const EtanolBalloonText = styled.Text`
  color: #fff;
  font-size: ${RFValue(9)}px;
  line-height: ${RFValue(11)}px;
  font-family: ${({ theme }) => theme.fonts.semibold};
  text-align: center;
`;

export const EtanolBalloonMascote = styled.Image<{ size?: number; onLeft?: boolean }>`
  width: ${({ size }) => RFValue(size ?? 26)}px;
  height: ${({ size }) => RFValue((size ?? 26) + 10)}px;
  position: absolute;
  ${({ size, onLeft }) =>
    onLeft
      ? `left: -${RFValue((size ?? 26) + 0)}px;`
      : `right: -${RFValue((size ?? 26) + 0)}px;`}
`;

export const EtanolBalloonArrow = styled.View`
  position: absolute;
  top: -${RFValue(5)}px;
  margin-left: -${RFValue(0)}px;
  width: 0;
  height: 0;
  border-left-width: ${RFValue(5)}px;
  border-right-width: ${RFValue(5)}px;
  border-bottom-width: ${RFValue(5)}px;
  border-left-color: transparent;
  border-right-color: transparent;
  border-style: solid;
  border-bottom-color: #B8100F;
`;

export const FuelItem = styled.View<{
  bgColor: string;
}>`
  width: 100%;
  background-color: ${({ bgColor }) => bgColor};
  padding-left: ${RFValue(8)}px;
  padding-right: ${RFValue(8)}px;
  min-height: ${RFValue(58)}px;
  padding-top: ${RFValue(5)}px;
  padding-bottom: ${RFValue(5)}px;
  border-radius: ${RFValue(10)}px;
  flex-direction: row;

  justify-content: space-between;
`;

export const FuelData = styled.View`
  align-items: flex-end;
  flex: 1;
  justify-content: space-between;
`;

export const FuelNameContainer = styled.View`
  align-items: flex-end;
  justify-content: flex-end;
`;

export const FuelFlag = styled.Text`
  font-family: ${({ theme }) => theme.fonts.fuel};
  color: ${({ theme }) => theme.colors.purple_2_shadow_white};
  font-size: ${RFValue(20)}px;
  margin-top: -6px;
`;
export const FuelName = styled.Text`
  color: ${({ theme }) => theme.colors.purple_2_shadow_white};
  font-size: ${RFValue(9)}px;
  line-height: ${Platform.OS === 'android' ? RFValue(11) : RFValue(12.5)}px;
  text-align: right;

  font-family: ${({ theme }) => theme.fonts.semibold};
`;

export const FuelItemInfo = styled.View`
  justify-content: space-between;
`;

export const AlertContainer = styled.View`
  padding: 0 16px;
  margin: 0 -16px;
`;

export const EncherTanqueContainer = styled(LinearGradient)<{ active?: boolean }>`
  flex: 1;
  justify-content: center;
  align-items: center;
  border: 2px solid ${({ theme }) => theme.colors.border};
  border-radius: ${RFValue(12)}px;
  
  ${({ active }) =>
    active &&
    css`
      border: 2px solid ${({ theme }) => theme.colors.blue};
    `}
`;

export const PumpIconContainer = styled.View`
  width: ${RFValue(22)}px;
  height: ${RFValue(22)}px;
  border-radius: ${RFValue(8)}px;
  background-color: rgba(255, 255, 255, 0.3);
  justify-content: center;
  align-items: center;
  margin-bottom: ${RFValue(4)}px;
`;

export const PumpIcon = styled(FontAwesome5)`
  color: ${({ theme }) => theme.colors.shape};
  font-size: ${RFValue(12)}px;
`;

export const TanqueCheioIcon = styled(FontAwesome5)`
  color: ${({ theme }) => theme.colors.title};
  font-size: ${RFValue(14)}px;
`;

export const EncherTanqueTitle = styled.Text`
  color: ${({ theme }) => theme.colors.shape};
  font-size: ${RFValue(9)}px;

  font-family: ${({ theme }) => theme.fonts.regular};
`;

export const EncherTanqueText = styled.Text`
  font-family: ${({ theme }) => theme.fonts.semibold};
  color: #fff;
  font-size: ${RFValue(10)}px;
  line-height: ${RFValue(10)}px;
  text-align: center;
`;

export const EncherInfos = styled.View`
  flex-direction: column;
`;

export const EncherTanqueColumn = styled.View`
  flex-direction: row;
  gap: ${RFValue(10)}px;
`;
export const EncherTanqueArrow = styled.View`
  width: ${RFValue(20)}px;
  height: ${RFValue(20)}px;
  justify-content: center;
  align-items: center;
  border-radius: ${RFValue(6)}px;
  background-color: ${({ theme }) => theme.colors.shape};
`;
export const EncherTanqueArrowIcon = styled(FontAwesome5)`
  font-size: ${RFValue(10)}px;
  `;

export const VolumeSelectorContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: ${RFValue(16)}px 24px;
  gap: ${RFValue(16)}px;
`;

export const VolumeArrowButton = styled.TouchableOpacity<{ disabled?: boolean }>`
  width: ${RFValue(44)}px;
  height: ${RFValue(44)}px;
  border-radius: ${RFValue(22)}px;
  border: 2px solid ${({ theme, disabled }) =>
    disabled ? theme.colors.border : theme.colors.blue};
  align-items: center;
  justify-content: center;
  opacity: ${({ disabled }) => (disabled ? 0.35 : 1)};
`;

export const VolumeArrowIcon = styled(Feather)`
  font-size: ${RFValue(20)}px;
  color: ${({ theme }) => theme.colors.blue};
`;

export const VolumeValueContainer = styled.View`
  align-items: center;
  justify-content: center;
  min-width: ${RFValue(100)}px;
`;

export const VolumeValue = styled.Text`
  color: ${({ theme }) => theme.colors.title};
  font-size: ${RFValue(32)}px;
  font-family: ${({ theme }) => theme.fonts.semibold};
`;

export const VolumeUnit = styled.Text`
  color: ${({ theme }) => theme.colors.text};
  font-size: ${RFValue(12)}px;
  font-family: ${({ theme }) => theme.fonts.regular};
  margin-top: ${RFValue(2)}px;
`;
